import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HammerGestureConfig } from '@angular/platform-browser';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export const environment = {
  production: false,
  mobile: false,
  product: 'wettarena',
  inheritProductName: '',
  loginredirect: '',
  leftsport: false,
  transactionDialogIsActive: true,
  submitBetModifyControl: false,
  IdleWarningIsActive: false,
  IdleWarningMinutes: 15,
  IsBet3000: true,
  IsRegisterActive: true,
  assetsPath: 'https://wettarenacdn.s3.amazonaws.com/desktop_test/assets/',
  assetsOnlyProject: false,
  contactUrl: 'mailto:support@ibc-betting.com',
  isDarkMode: true,
  isNewCashout: false,
  newCashoutUrl: 'https://cashout-dev-wa.arita.cloud',
  recaptcha: {
    siteKey: '6LdpAg4jAAAAAH6YrD-sChoCt6GCCx6sSFiqBJAK',
  },
  healthUrl: 'https://www.bzga.de/',
  supportMail: 'support@ibc-betting.com',
  tracker_Operator: 'BetRadar',
  tracker_ConfigurationId: '',
  tracker_ProviderId: 0,
  tracker_GroupId: '',
  IsBetStopReasonHeader: false,
  IsBetStopReasonMatchRow: false,
  idleObject: {
    isOpenIdleModal: true,
    idleTime: 60 * 60 * 1000, // by Seconds 30minutes
  },
  lugasCheck: true,
};
export const passwordRegex = '^(?=.*[A-Z])(?=.*[!.@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,25}$';
export const FOOTER_TEXT_KEY = {
  addressTextHeader: 'footer_text_12',
  addressText: 'footer_text_11',
};

export const LANGUAGES = ['de', 'en', 'tr']; //['en', 'tr', 'de', 'ku', 'ar', 'vi', 'es', 'fr', 'el', 'ru', 'pl', 'bg', 'da', 'sr', 'sq', 'pt', 'ro'];
export const DefaultLangCode = 'en';
export const DefaultLangId = 2;
export const EnableCookieConsent = false;
export const EnableIdleTimer = false;
export const DefaultSlipAmount = 2;
export const MinSlipAmount = 1;

export const EasyPasswordEnabled = false;

export const AvailableCountries = ['ok'];

export const SocketURL = 'https://msocket2023.wettarena.de';
export const CashoutURL = '/api/';

export const LEAGUESLIDER = [
  {
    FileName: 'angular/dist/assets/images/league/premiere.svg',
    route: '/league',
    TourId: '107',
    CatId: '1',
  },
  {
    FileName: 'angular/dist/assets/images/league/Bundesliga_logo.svg',
    route: '/league',
    TourId: '16',
    CatId: '13',
  },
  {
    FileName: 'angular/dist/assets/images/league/LaLiga.svg',
    route: '/league',
    TourId: '128',
    CatId: '15',
  },
  {
    FileName: 'angular/dist/assets/images/league/serie-a-seeklogo.com.svg',
    route: '/league',
    TourId: '236',
    CatId: '14',
  },
  {
    FileName: 'angular/dist/assets/images/league/spor_toto_super_lig_logo.svg',
    route: '/league',
    TourId: '133',
    CatId: '16',
  },
  {
    FileName: 'angular/dist/assets/images/league/Ligue_1_logo.svg',
    route: '/league',
    TourId: '167',
    CatId: '99',
  },
];

export const BOTTOM_NAVBAR_ITEMS = [
  { route: '/allsports', name: 'b3000_sports', id: 2, svgUrl: 'sports', count: 0, isCountZeroHide: false },
  { route: '/live', name: 'b3000_live', id: 3, svgUrl: 'in-play', count: 0, isCountZeroHide: false },
  { route: '/home', name: 'b3000_home', id: 1, svgUrl: 'home', count: 0, isCountZeroHide: false },
  { route: '/mybets', name: 'b3000_my_bets', id: 4, svgUrl: 'my-bets', count: 0, isCountZeroHide: false },
  { route: '/betslip', name: 'b3000_bet_slip', id: 15, svgUrl: 'bet-slip', count: 0, isCountZeroHide: false },
];

export const avsconfig_online = {
  apiUrl: 'https://ibc.insic.net/api/',
  resourceUrl: 'https://ibc.insic.net/frontend2/',
  partnerId: '4563fcb6-41a9-4324-ad0a-72b8917df8e0',
  onlineBranchId: 32643,
};

export const avsconfig_shop = {
  apiUrl: 'https://ibc.insic.net/api/',
  resourceUrl: 'https://ibc.insic.net/frontend2/',
  partnerId: 'f83bee26-7586-4553-a7a1-4c20c6adb83a',
};

export const avsconfig_sow = {
  apiUrl: 'https://iba.insic.net/api/',
  resourceUrl: 'https://iba.insic.net/frontend2/',
  partnerId: '57debb5f-4a6b-4b5a-a6aa-9c46df6891da',
};

export const CASINO_LOBBY_GAMES = [
  //{ "id": 0, "name": "Live Casino", "path": "/livecasino", "provider": 0, "text": "Live Casino", "img": "/angular/dist/assets/images/casino/lobby/xpg.jpg" },
  //{ "id": 16, "name": "Evolution", "path": "/casinotrslobby/EVOLUTION", "provider": 16, "text": "Evolution Live Casino", "img": "/angular/dist/assets/images/casino/lobby/evolution.png" },
  { id: 56, name: 'Vivo', path: '/casinovivolobby/0', provider: 34, text: 'Vivo Live Casino', img: '/angular/dist/assets/images/casino/lobby/vivo_lobby.png' },
  //{ "id": 16, "name": "Evolution", "path": "/casinogroupgalobby/480", "provider": 480, "text": "Evolution Live Casino", "img": "/angular/dist/assets/images/casino/lobby/evolution.png" },
  //{ "id": 46, "name": "Ezugi", "path": "/casinoxp/46", "provider": 46, "text": "Live Table Games", "img": "/angular/dist/assets/images/casino/lobby/ezugi.jpg" },
  { id: 22, name: 'Netent', path: '/casinoslotlobby/netent', provider: 22, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/netent.png' },
  //{ "id": 67, "name": "Hollywood TV", "path": "/casinoxp/67", "provider": 67, "text": "Keno", "img": "/angular/dist/assets/images/casino/lobby/hollywood.jpg" },
  //{ "id": 1, "name": "Spinmatic", "path": "/casinotrslobby/AMATIC", "provider": 1, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/spinmatic.jpg" },
  //{ "id": 48, "name": "Habanero", "path": "/casinoxp/48", "provider": 48, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/habanero.jpg" },
  { id: 19, name: 'Novomatic', path: '/casinoslotlobby/novomatic', provider: 19, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/novomatic.png' },
  //{ "id": 21, "name": "Playtech", "path": "/casinoxp/21", "provider": 21, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/playtech.jpg" },
  //{ "id": 8, "name": "Pragmatic Play", "path": "/casinotrslobby/EGT", "provider": 8, "text": "Video Table Games", "img": "/angular/dist/assets/images/casino/lobby/egt.jpg" },
  //{ "id": 55, "name": "Spinomenal", "path": "/casinoxp/55", "provider": 55, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/spinomenal.jpg" },
  //{ "id": 6, "name": "Gameart", "path": "/casinotrslobby/YGGDRASIL", "provider": 6, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/gameart.jpg" }
  { id: 57, name: 'BS', path: '/casinobslobby', provider: 57, text: 'Bet Solutions', img: '/angular/dist/assets/images/casino/lobby/7001_466x292.png' },
  //{ "id": 58, "name": "BS", "path": "/casinobslobby", "provider": 58, "text": "Slots", "img": "/angular/dist/assets/images/casino/lobby/2_466x292.png" },
  //{ "id": 59, "name": "BS", "path": "/casinobslobby", "provider": 59, "text": "Dice", "img": "/angular/dist/assets/images/casino/lobby/7002_466x292.png" },
  //{ "id": 60, "name": "BS", "path": "/casinobslobby", "provider": 60, "text": "Okey", "img": "/angular/dist/assets/images/casino/lobby/5001_466x292.png" },
  //{ "id": 61, "name": "BS", "path": "/casinobslobby", "provider": 61, "text": "Backgammon", "img": "/angular/dist/assets/images/casino/lobby/5000_466x292.png" },
  //{ "id": 62, "name": "BS", "path": "/casinobslobby", "provider": 62, "text": "Domino", "img": "/angular/dist/assets/images/casino/lobby/5003_466x292.png" },
  //{ "id": 63, "name": "BS", "path": "/casinobslobby", "provider": 63, "text": "Poker", "img": "/angular/dist/assets/images/casino/lobby/7_466x292.png" },
  { id: 30, name: 'Amatic', path: '/casinoslotlobby/amatic', provider: 30, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/amatic.png' },
  { id: 31, name: 'EGT', path: '/casinoslotlobby/egt', provider: 31, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/egt.png' },
  { id: 32, name: 'YGGDRASIL', path: '/casinoslotlobby/yggdrasil', provider: 32, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/YGGDRASIL.png' },
  //{ "id": 33, "name": "Wazdan", "path": "/casinoslotlobby/wazdan", "provider": 33, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/wazdan.png" },
  { id: 34, name: 'Pragmatic', path: '/casinoslotlobby/pragmatic', provider: 34, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/pragmatic.png' },
  // { "id": 35, "name": "Noble", "path": "/casinoslotlobby/noble", "provider": 35, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/noble.png" },
  { id: 117, name: 'TomHorn', path: '/casinovivolobby/1', provider: 34, text: 'Tom Horn', img: '/angular/dist/assets/images/casino/lobby/tomhorn.jpg' },
  { id: 118, name: 'BetSoft', path: '/casinovivolobby/2', provider: 34, text: 'Bet Soft', img: '/angular/dist/assets/images/casino/lobby/betsoft.jpg' },
  { id: 201, name: 'Nucleus', path: '/casinovivolobby/3', provider: 34, text: 'Nucleus', img: '/angular/dist/assets/images/casino/lobby/nucleus.jpg' },
  { id: 202, name: 'ArrowsEdge', path: '/casinovivolobby/4', provider: 34, text: 'Arrows Edge', img: '/angular/dist/assets/images/casino/lobby/arrowsedge.jpg' },
  { id: 203, name: 'Platipus', path: '/casinovivolobby/5', provider: 34, text: 'Platipus', img: '/angular/dist/assets/images/casino/lobby/platipus.jpg' },
  { id: 204, name: 'RedRake', path: '/casinovivolobby/6', provider: 34, text: 'Red Rake', img: '/angular/dist/assets/images/casino/lobby/redrake.jpg' },
  { id: 205, name: 'Leap', path: '/casinovivolobby/7', provider: 34, text: 'Leap', img: '/angular/dist/assets/images/casino/lobby/leap.jpg' },

  { id: 36, name: 'Bomba', path: '/casinoslotlobby/bomba', provider: 36, text: 'Slot Games', img: '/angular/dist/assets/images/casino/lobby/bomba.png' },

  //  { "id": 33, "name": "Novomatic", "path": "/casinotrslobby/NOVOMATIC", "provider": 19, "text": "Slot Games", "img": "/angular/dist/assets/images/casino/lobby/novomatic.png" },
  // RISE UP
  // RISE UP
  //{ "id": 33, "name": "Dbg", "path": "/casinorulobby/Dbg", "provider": 33, "text": "DBG POKER", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 34, "name": "Evolution", "path": "/casinorulobby/Evolution", "provider": 34, "text": "EVOLUTION GAMING", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 35, "name": "Amatic", "path": "/casinorulobby/Amatic", "provider": 35, "text": "AMATIC", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 36, "name": "Egt", "path": "/casinorulobby/Egt", "provider": 36, "text": "EGT", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 37, "name": "Novomatic", "path": "/casinorulobby/Novomatic", "provider": 37, "text": "NOVOMATIC", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 38, "name": "Noble", "path": "/casinorulobby/Noble", "provider": 38, "text": "NOBLE", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 39, "name": "Atronic", "path": "/casinorulobby/Atronic", "provider": 39, "text": "ATRONIC", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 40, "name": "Bomba", "path": "/casinorulobby/Bomba", "provider": 40, "text": "BOMBA GAMES", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 41, "name": "Evoplay", "path": "/casinorulobby/Evoplay", "provider": 41, "text": "EVOPLAY", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 42, "name": "GameArt", "path": "/casinorulobby/GameArt", "provider": 42, "text": "GAME ART", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 43, "name": "Habanero", "path": "/casinorulobby/Habanero", "provider": 43, "text": "HABANERO", "img": "/angular/dist/assets/images/casino/lobby/habanero.jpg" },
  //{ "id": 44, "name": "Igt", "path": "/casinorulobby/Igt", "provider": 44, "text": "IGT", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 45, "name": "ISoftBet", "path": "/casinorulobby/ISoftBet", "provider": 45, "text": "ISOFTBET", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 46, "name": "IGrosoft", "path": "/casinorulobby/IGrosoft", "provider": 46, "text": "IGROSOFT", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 47, "name": "Netent", "path": "/casinorulobby/Netent", "provider": 47, "text": "NETENT", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 48, "name": "Playson", "path": "/casinorulobby/Playson", "provider": 48, "text": "PLAYSON", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 49, "name": "XPlosive", "path": "/casinorulobby/XPlosive", "provider": 49, "text": "XPLOSIVE SLOTS", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 50, "name": "Gaminator", "path": "/casinorulobby/Gaminator", "provider": 50, "text": "GAMINATOR", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 51, "name": "YGGDrasil", "path": "/casinorulobby/YGGDrasil", "provider": 51, "text": "YGGDRASIL", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 52, "name": "Quickspin", "path": "/casinorulobby/Quickspin", "provider": 52, "text": "QUICKSPIN", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 53, "name": "1X2", "path": "/casinorulobby/1x2", "provider": 53, "text": "1X2", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 54, "name": "Wazdan", "path": "/casinorulobby/Wazdan", "provider": 54, "text": "WAZDAN", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 55, "name": "Tablegames", "path": "/casinorulobby/Tablegames", "provider": 55, "text": "TABLE GAMES", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  //{ "id": 56, "name": "IronDog", "path": "/casinorulobby/IronDog", "provider": 56, "text": "IRONDOG", "img": "/angular/dist/assets/images/casino/lobby/evolution.jpg" },
  // RISE UP
  { id: 55, name: 'dsvirtual', path: '/casinodsvirtual', provider: 33, text: 'DS Virtual', img: '/angular/dist/assets/images/casino/lobby/dsvirtual.png' },
  { id: 100, name: 'groupgamicro', path: '/casinogroupgalobby/407', provider: 407, text: 'Microgaming', img: '/angular/dist/assets/images/casino/lobby/microgaming.png' },
  //, { "id": 101, "name": "groupga1x2", "path": "/casinogroupgalobby/201", "provider": 201, "text": "1x2 Gaming", "img": "/angular/dist/assets/images/casino/lobby/1x2gaming.png" }
  //, { "id": 102, "name": "groupgagameart", "path": "/casinogroupgalobby/221", "provider": 221, "text": "Game Art", "img": "/angular/dist/assets/images/casino/lobby/gameart.png" }
  //, { "id": 103, "name": "groupgagaminator", "path": "/casinogroupgalobby/196", "provider": 196, "text": "Gaminator", "img": "/angular/dist/assets/images/casino/lobby/gaminator.png" }
  //, { "id": 104, "name": "groupgaplayson", "path": "/casinogroupgalobby/194", "provider": 194, "text": "Playson", "img": "/angular/dist/assets/images/casino/lobby/playson.png" }
  //, { "id": 105, "name": "groupgaxplosive", "path": "/casinogroupgalobby/195", "provider": 195, "text": "Xplosive Slots", "img": "/angular/dist/assets/images/casino/lobby/xplosive.png" }
  { id: 106, name: 'groupgaigro', path: '/casinogroupgalobby/377', provider: 377, text: 'Igrosoft', img: '/angular/dist/assets/images/casino/lobby/igrosoft.png' },
  //, { "id": 107, "name": "groupgaains", "path": "/casinogroupgalobby/446", "provider": 446, "text": "Ainsworth", "img": "/angular/dist/assets/images/casino/lobby/ainsworth.png" }
  { id: 108, name: 'groupgaapollo', path: '/casinogroupgalobby/434', provider: 434, text: 'Apollo', img: '/angular/dist/assets/images/casino/lobby/apollo.png' },
  { id: 109, name: 'groupgaaristo', path: '/casinogroupgalobby/401', provider: 401, text: 'Aristocrat', img: '/angular/dist/assets/images/casino/lobby/aristo.png' },
  //, { "id": 110, "name": "groupgafish", "path": "/casinogroupgalobby/416", "provider": 416, "text": "Fish", "img": "/angular/dist/assets/images/casino/lobby/fish.png" }
  { id: 111, name: 'groupgahabanero', path: '/casinogroupgalobby/443', provider: 443, text: 'Habanero', img: '/angular/dist/assets/images/casino/lobby/habanero.png' },
  //, { "id": 112, "name": "groupgaigt", "path": "/casinogroupgalobby/386", "provider": 386, "text": "IGT", "img": "/angular/dist/assets/images/casino/lobby/igt.png" }
  { id: 113, name: 'groupgamerkur', path: '/casinogroupgalobby/440', provider: 440, text: 'Merkur', img: '/angular/dist/assets/images/casino/lobby/merkur.png' },
  //, { "id": 114, "name": "groupgascientific", "path": "/casinogroupgalobby/425", "provider": 425, "text": "Scientific Games", "img": "/angular/dist/assets/images/casino/lobby/scientific.png" }
  //, { "id": 115, "name": "groupgatomhorn", "path": "/casinogroupgalobby/431", "provider": 431, "text": "Tom Horn", "img": "/angular/dist/assets/images/casino/lobby/tomhorn.png" }
  { id: 116, name: 'groupgawaz', path: '/casinogroupgalobby/428', provider: 428, text: 'Wazdan', img: '/angular/dist/assets/images/casino/lobby/wazdan.png' },
];

// IFRAME Sport Radar Statistic

// IFRAME Sport Radar Statistic
export const getStatistic = (LangId, SportId, TournamentId) => {
  return 'https://st-cdn001.akamaized.net/wettarena/' + LangId + '/uniquetournament/' + TournamentId;

  // return 'https://s5.sir.sportradar.com/wettarena/' + LangId + '/uniquetournament/' + TournamentId;

  // https://s5.sir.sportradar.com/wettarena/de/uniquetournament/98
  // return 'https://s5.sir.sportradar.com/wettarena/' + LangId + '/tournament/' + TournamentId;

  // https://s5dev.sir.sportradar.com/wettarena/en/tournament/33
};

// IFRAME Sport Radar Head To Head
export const getHeadToHead = (LangId, SportId, TournamentId, BetradarMatchId) => {
  return 'https://st-cdn001.akamaized.net/wettarena/' + LangId + '/match/' + BetradarMatchId;

  // return 'https://s5.sir.sportradar.com/wettarena/' + LangId + '/match/' + BetradarMatchId;

  // https://s5dev.sir.sportradar.com/wettarena/en/match/xxxxxx
};

// PAGE Sport Radar Statistic
export const getStatisticPage = LangId => {
  return 'https://st-cdn001.akamaized.net/wettarena/' + LangId;

  // return 'https://s5.sir.sportradar.com/wettarena/' + LangId;
};

// PAGE Sport Radar Statistic
export const getLiveScorePage = LangId => {
  return 'https://ls-cdn001.akamaized.net/wettarena/' + LangId;

  // return 'https://ls.sir.sportradar.com/wettarena/' + LangId;
};

// BETGENIUS

export const getBetGeniusLiveTracker = (BetradarMatchId, LangId) => {
  const url = 'https://bsdemo.betstream.betgenius.com/betstream-view/page/betgenius/footballscorecentre?eventId=' + (-1 * BetradarMatchId).toString();
  return url;
};

// BETGENIUS

// Bet3000 Ended Match Results Page
export const getEndedMatchResultsPage = (BetradarMatchId, LangId) => {
  return 'https://ls-cdn001.akamaized.net/wettarena/' + LangId + '/match/' + BetradarMatchId;
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

@NgModule({
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatBottomSheetModule,
    A11yModule,
    DragDropModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
  ],
  providers: [
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
  ],
})
export class MaterialImports {}
export class AritaHammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {
      direction: 6,
    },
    pinch: {
      enable: false,
    },
    rotate: {
      enable: false,
    },
  };
}
